export interface PayloadInterface {
  id?: string | number;
}
